import { render, staticRenderFns } from "./ImportedOccupationsPage.vue?vue&type=template&id=403207a2&scoped=true&"
import script from "./ImportedOccupationsPage.vue?vue&type=script&lang=js&"
export * from "./ImportedOccupationsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=403207a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403207a2",
  null
  
)

export default component.exports